<template>
  <!-- Welcome-mail-template start -->
  <div
    class="modal fade welcomemailmodal ss-reg-type-sidebar-modal"
    id="welcomemailModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
      v-show="emailTemplate"
    >
      <div class="modal-content">
        <div class="modal-body welcome-modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            ref="close_sendmail_modal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="welcome-mail-tab welcome-mail-customize-width">
            <p class="mb-2">Choose Template</p>
            <div class="switch-field-page-tab mb-0">
              <input
                type="radio"
                id="radio-eight"
                name="switch-four"
                value="no"
                v-if="templateAnnouncement"
                @click="getMailTemplate(templateAnnouncement)"
              />
              <label for="radio-eight" v-if="templateAnnouncement">{{
                templateAnnouncement.replace("Mail", "")
              }}</label>
              <input
                type="radio"
                id="radio-seven"
                name="switch-four"
                value="yes"
                v-if="templateReminder == 'ReminderMail'"
                checked
                @click="getMailTemplate(templateReminder)"
              />
              <label for="radio-seven" v-if="templateReminder == 'ReminderMail'">{{
                templateReminder.replace("Mail", "")
              }}</label>
              
            </div>
          </div>
          <div class="email-temp-wrap mt-4" v-if="emailTemplate">
            <v-tabs vertical>
              <v-tab>
                <v-icon color="#959595" size="20px" class="mr-2"
                  >mdi-eye-circle-outline</v-icon
                >
                Preview
              </v-tab>
              <v-tab
                ><v-icon color="#959595" size="20px" class="mr-2"
                  >mdi-pencil-outline</v-icon
                >
                Edit
              </v-tab>
              <v-tab
                ><v-icon color="#959595" size="20px" class="mr-2"
                  >mdi-format-list-bulleted</v-icon
                >
                Recepients
              </v-tab>
              <v-tab-item>
                <v-card flat>
                  <h4>Sub: {{ emailTemplate.docData.subject }}</h4>
                  <div class="email-body" v-html="emailTemplate.docData.html"></div>
                </v-card>
                <div
                  class="submit-form-switch justify-content-center justify-content-lg-end justify-content-md-center"
                >
                  <v-btn
                    dark
                    outlined
                    color="#1c1d26"
                    class="cancel-form cancel-standard"
                    data-dismiss="modal"
                    width="120px"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    dark
                    color="#2376e5"
                    class="save-form save-standard"
                    @click="sendMailToActiveUsers()"
                    width="120px"
                  >
                    Send
                  </v-btn>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-text-field
                    v-model="emailTemplate.docData.subject"
                    label="Subject"
                    required
                  ></v-text-field>
                  <ckeditor
                    class=""
                    v-model="emailTemplate.docData.html"
                    :config="editorConfig"
                  >
                  </ckeditor>
                </v-card>
                <div class="submit-form-switch flex-column flex-md-row">
                  <div
                    class="d-flex justify-content-start justify-content-md-end align-items-center"
                  >
                    <label class="mr-1">Schedule Reminder before:</label>
                    <v-checkbox
                      class="mr-1"
                      :label="`${item.time} ${item.timeIn}`"
                      :value="item"
                      v-model="selectedEmailScheduleTimes"
                      v-for="(item, index) in emailScheduleTimes"
                      :key="index"
                    ></v-checkbox>
                  </div>
                  <div
                    class="d-flex d-md-inline-block justify-content-start align-items-center"
                  >
                    <button class="cancel-form ml-2" data-dismiss="modal">Cancel</button>
                    <button class="save-form" @click="saveMailTemplate()">Save</button>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-simple-table fixed-header height="400px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th><v-checkbox v-model="checkAllUsers" @click="checkUncheckAllUsers" /></th>
                        <th>Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index) in userList" :key="index">
                        <td v-if="templateReminder == 'Speaker'">
                          <v-checkbox v-model="recepientList" :value="user.SpeakerId" />
                        </td>
                        <td v-else>
                          <v-checkbox v-model="recepientList" :value="user.AttendeeId" />
                        </td>
                        <td>{{ user.Name }}</td>
                        <td>{{ user.Email }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div
                  class="submit-form-switch justify-content-center justify-content-lg-end justify-content-md-center"
                >
                  <v-btn
                    dark
                    outlined
                    color="#1c1d26"
                    class="cancel-form cancel-standard"
                    data-dismiss="modal"
                    width="120px"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    dark
                    color="#2376e5"
                    class="save-form save-standard"
                    @click="sendMailToActiveUsers()"
                    width="120px"
                  >
                    Send
                  </v-btn>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Welcome-mail-template end -->
</template>
<script>
import APIs from "@/components/APIInit";
var self;
// import Vue from "vue";
import axios from "axios";
import { bus } from "@/main";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

export default {
  data() {
    return {
      eventid: null,
      clientID: null,
      event_collectionName: null,
      userID: null,
      editorConfig: CKconfig.editorConfig,
      templateReminder: "ReminderMail",
      templateAnnouncement: "AnnouncementMail",
      emailTemplate: null,
      emailScheduleTimes: [
        {
          time: 5,
          timeIn: "min",
        },
        {
          time: 4,
          timeIn: "hour",
        },
        {
          time: 24,
          timeIn: "hour",
        },
      ],
      recepientList: [],
      userList: [],
      checkAllUsers: false
    };
  },
  components: {
    ckeditor: CKEditor.component,
  },
  computed: {},
  watch: {},
  created() {
    self = this;
    self.clientID = self.getClientId();
    self.eventid = self.getEventId();
    self.event_collectionName = self.getEventCollectionName();
    self.userID = self.getSessionUserId();
    self.recepientList = [];
    self.userList = [];    
  },
  mounted() {},
  methods: {
    checkUncheckAllUsers(){
      if(self.checkAllUsers){
        for(let item of self.userList){
          if (self.templateReminder == "Speaker")
            self.recepientList.push(item.SpeakerId);
          else
            self.recepientList.push(item.AttendeeId);
        }
      }else{
        self.recepientList = [];
      }
    },
    async getMailTemplate(templateName) {
      if (self.templateReminder == "Speaker") {
        await self.getAllActiveSpeakers().catch();
      } else {
        await self.getAllActiveAttendees().catch();
      }

      let EventAccessType = self.getCurrentEvent().EventAccessType;
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
        templateName: templateName,
      };
      axios
        .post(APIs.GetMailTemplate, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0 && res.data.data.length) {
            let templates = res.data.data;
            templates.forEach((item) => {
              if (
                EventAccessType == "Use Common Event Passcode" &&
                item.docId.includes("EventAccess")
              ) {
                self.emailTemplate = item;
              } else if (!item.docId.includes("EventAccess")) {
                self.emailTemplate = item;
              }
            });
            if (self.emailTemplate.selectedEmailScheduleTimes)
              self.selectedEmailScheduleTimes =
                self.emailTemplate.selectedEmailScheduleTimes;
            else self.selectedEmailScheduleTimes = self.emailScheduleTimes;
          } else self.showSnackbar("No template to fetch!", "error", "top");
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    saveMailTemplate() {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
        template: {
          docData: {
            html: self.emailTemplate.docData.html,
            subject: self.emailTemplate.docData.subject,
          },
          docId: self.emailTemplate.docId,
          collectionName: String(self.emailTemplate.docId)
            .toLowerCase()
            .includes("reminder")
            ? self.templateReminder
            : self.templateAnnouncement,
        },
      };
      axios
        .post(APIs.SetMailTemplate, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            self.showSnackbar("Template updated.", "success", "top");
            self.scheduleEmailSend();
          } else self.showSnackbar("Template not updated!", "error", "top");
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    sendMailToActiveUsers() {
      if (self.templateReminder == "Speaker") {
        self.sendMailToSpeakers();
      } else {
        self.sendMailToAttendess();
      }
    },
    sendMailToSpeakers() {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
      };
      if (self.recepientList.length) {            
        let bodyData = {
          instanceID: "OA_UAT",
          clientID: self.clientID,
          eventID: self.eventid,
          userIdList: self.recepientList,
          templateName: self.emailTemplate.docId,
          recipientType: "Speaker",
        };
        axios
          .post(APIs.BulkEmailSend, bodyData, { headers: headers })
          .then((res) => {
            bus.$emit("toggleLoader", false);
            self.$refs.close_sendmail_modal.click();
            if (res.data.status == 0)
              self.showSnackbar("Mail sent to Users.", "success", "top");
            else self.showSnackbar("Unable to send mail!", "error", "top");
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      } else {
        bus.$emit("toggleLoader", false);
        self.showSnackbar("Please select Recepients!", "error", "top");
      }        
    },
    sendMailToAttendess() {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
      };
      if (self.recepientList.length) {            
        let bodyData = {
          instanceID: "OA_UAT",
          clientID: self.clientID,
          eventID: self.eventid,
          userIdList: self.recepientList,
          templateName: self.emailTemplate.docId,
        };
        axios
          .post(APIs.BulkEmailSend, bodyData, { headers: headers })
          .then((res) => {
            bus.$emit("toggleLoader", false);
            self.$refs.close_sendmail_modal.click();
            if (res.data.status == 0)
              self.showSnackbar("Mail sent to Users.", "success", "top");
            else self.showSnackbar("Unable to send mail!", "error", "top");
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      } else {
        bus.$emit("toggleLoader", false);
        self.showSnackbar("Please select Recepients!", "error", "top");
      }        
    },
    getAllActiveSpeakers() {
      self.recepientList = [];
      self.userList = [];
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        };
        axios
          .get(APIs.speakerList, { headers: headers })
          .then(function (res) {
            let speakers = [];
            if (res.data.status == 0 && res.data.results.length) {
              for (let item of res.data.results) {
                if (item.IsPublished) speakers.push(item);
              }
            }
            self.userList = speakers;
            resolve(speakers);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllActiveAttendees() {
      self.recepientList = [];
      self.userList = [];
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          },
          data: {
            search: [],
            filter: [
              {
                key: "IsPublished",
                operator: "==",
                value: true,
              },
            ],
            sort: { sortBy: "FirstName", sortOrder: "asc" },
            pagination: {
              Page: 1,
              PageSize: 9999,
            },
            origin: "COMPACT",
          },
        };
        axios
          .post(APIs.AttendeeSearch, requestData, { headers: headers })
          .then(function (res) {
            let attendees = [];
            if (res.data.status == 0 && res.data.result.length) {
              attendees = res.data.result;
            }
            self.userList = attendees;
            resolve(attendees);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async scheduleEmailSend() {
      let startDate = self.getCurrentEvent().EventStartDate.seconds * 1000;
      let userIdList = self.userList;      
      for (let key in self.selectedEmailScheduleTimes) {
        let ScheduleTime = self.selectedEmailScheduleTimes[key];
        let timeInMin =
          ScheduleTime.timeIn == "hour" ? ScheduleTime.time * 60 : ScheduleTime.time;
        let scheduledTaskId = `${self.Environment()}_${self.clientID}_${self.eventid}_SS${
          key + 1
        }`;
        let NotificationDateTime = new Date(startDate);
        NotificationDateTime.setMinutes(
          NotificationDateTime.getMinutes() - Number(timeInMin)
        );
        let scheduleInUTC = {
          year: NotificationDateTime.getUTCFullYear(),
          month: NotificationDateTime.getUTCMonth() + 1,
          day: NotificationDateTime.getUTCDate(),
          hour: NotificationDateTime.getUTCHours(),
          minute: NotificationDateTime.getUTCMinutes(),
        };
        let headers = {
          "Content-Type": "application/json",
        };
        let requestBody = {
          url: APIs.BulkEmailSend,
          body: {
            instanceID: "OA_UAT",
            clientID: self.clientID,
            eventID: self.eventid,
            userIdList: userIdList,
            templateName: self.emailTemplate.docId,
            recipientType:
              String(self.templateReminder).toLowerCase() == "speaker" ? "Speaker" : null,
            subject:
              "Event is about to start in " +
              ScheduleTime.time +
              " " +
              ScheduleTime.timeIn +
              "s",
            data: {},
            key: {
              instanceId: "OA_UAT",
              clientId: self.clientID,
              eventId: self.eventid,
            },
          },
        };
        await axios.post(
          APIs.SchedulingAPI,
          {
            scheduledTaskId: scheduledTaskId,
            request: requestBody,
            scheduleInUTC: scheduleInUTC,
          },
          { headers: headers }
        );
      }
      // })
      // .catch();
    },
  },
};
</script>
